module.exports = __webpack_public_path__ + "img/bg4.2e6dded4.jpg";